var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 67,
    viewBox: "0 0 54 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6418 26.1154V22.2043C19.6455 21.2601 20.0198 20.3557 20.6826 19.6893C21.3455 19.023 22.2429 18.6488 23.1785 18.6488H30.8154C31.751 18.6488 32.6484 19.023 33.3113 19.6893C33.9741 20.3557 34.3484 21.2601 34.3521 22.2043V26.1439H37.8465V22.2043C37.8465 20.3184 37.1043 18.5096 35.783 17.176C34.4618 15.8425 32.6699 15.0933 30.8014 15.0933H23.1785C21.31 15.0933 19.518 15.8425 18.1968 17.176C16.8756 18.5096 16.1333 20.3184 16.1333 22.2043V26.1439L19.6418 26.1154Z",
    fill: "url(#paint0_linear_95_1737)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4284 53.8202C46.9191 46.8872 47.4232 35.1377 40.5545 27.577C33.6858 20.0162 22.0452 19.5074 14.5545 26.4404C7.06383 33.3734 6.55968 45.1229 13.4284 52.6836C20.2972 60.2443 31.9377 60.7532 39.4284 53.8202Z",
    fill: "url(#paint1_linear_95_1737)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8006 53.1569C45.9128 46.5742 46.3915 35.4185 39.8698 28.2399C33.3482 21.0612 22.2959 20.5781 15.1838 27.1607C8.07165 33.7433 7.59298 44.899 14.1146 52.0777C20.6362 59.2563 31.6885 59.7395 38.8006 53.1569Z",
    fill: "url(#paint2_linear_95_1737)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0598 51.1946C43.1203 45.5813 43.5251 36.0718 37.9638 29.9545C32.4026 23.8373 22.9812 23.4287 16.9206 29.042C10.8601 34.6553 10.4553 44.1648 16.0166 50.2821C21.5779 56.3994 30.9992 56.8079 37.0598 51.1946Z",
    fill: "url(#paint3_linear_95_1737)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2211 47.6189V45.3149H23.7571V43.2269L28.5271 34.1189H30.6511V42.8849H31.6771V45.3149H30.6511V47.6189H28.2211ZM25.8091 43.8749L25.1971 42.8849H28.2211V38.9609L25.8091 43.8749Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.45
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0889 41.12C13.0858 38.2064 13.9224 35.3547 15.4968 32.9126C17.0713 30.4705 19.3155 28.5433 21.956 27.366C24.5964 26.1886 27.5192 25.812 30.3681 26.2819C33.2169 26.7518 35.8689 28.048 38.0007 30.0125C36.6435 28.5182 35.0007 27.3166 33.1712 26.4802C31.3417 25.6438 29.3634 25.1899 27.3555 25.1459C25.3476 25.1018 23.3516 25.4686 21.4878 26.224C19.624 26.9793 17.9311 28.1077 16.5109 29.5412C15.0907 30.9746 13.9728 32.6834 13.2244 34.5646C12.476 36.4458 12.1127 38.4605 12.1563 40.4872C12.2 42.5139 12.6496 44.5108 13.4783 46.3574C14.3069 48.204 15.4973 49.8622 16.9778 51.232C14.4705 48.4732 13.0823 44.8638 13.0889 41.12V41.12Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.67
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4376 28.4907C38.8375 31.3812 40.2637 34.9676 40.5098 38.7307C40.5098 42.7176 38.9406 46.5413 36.1475 49.3605C33.3545 52.1797 29.5662 53.7635 25.6162 53.7635C21.8854 53.527 18.3287 52.086 15.4712 49.6533C16.7922 51.2694 18.4332 52.589 20.2891 53.5273C22.145 54.4657 24.1747 55.0021 26.248 55.1022C28.3213 55.2023 30.3925 54.8639 32.3286 54.1086C34.2647 53.3533 36.0231 52.1978 37.4908 50.7164C38.9586 49.2349 40.1033 47.4601 40.8516 45.5059C41.5999 43.5516 41.9352 41.4611 41.836 39.3684C41.7369 37.2756 41.2054 35.2269 40.2758 33.3537C39.3461 31.4804 38.0388 29.824 36.4376 28.4907V28.4907Z",
    fill: "#F44B16"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.969 0.4021L22.3324 18.5638C22.2434 18.7877 22.2122 19.0308 22.2418 19.2702C22.2715 19.5095 22.361 19.7374 22.5019 19.9322C22.6428 20.1271 22.8305 20.2826 23.0474 20.384C23.2642 20.4855 23.5031 20.5296 23.7415 20.5123H25.1505L32.5057 0.4021H28.969Z",
    fill: "#1268C6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4213 0.4021L25.0662 20.5123H28.5042L35.8735 0.4021H32.4213Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8588 0.401986L30.2227 15.7619L28.5037 20.4837H30.9554C31.2864 20.4804 31.6056 20.3595 31.8572 20.1424C32.0603 19.9874 32.2125 19.7743 32.294 19.5308L39.3391 0.373535L35.8588 0.401986Z",
    fill: "#EB3723"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.69,
    d: "M34.126 14.5958L32.2943 19.5593C32.2161 19.8045 32.0632 20.0185 31.8575 20.1709C31.61 20.3948 31.2881 20.5167 30.9557 20.5122H23.671C23.4308 20.5307 23.19 20.4868 22.9714 20.3846C22.7529 20.2825 22.5639 20.1255 22.4226 19.9286C22.2813 19.7318 22.1923 19.5016 22.1642 19.2602C22.1361 19.0188 22.1697 18.7741 22.2619 18.5495L28.8703 0.473145L34.126 14.5958Z",
    fill: "url(#paint4_linear_95_1737)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6163 0.4021H21.1782L28.5193 20.4838H30.9428C31.2738 20.4805 31.5931 20.3596 31.8446 20.1425L30.2242 15.7336L24.6163 0.4021Z",
    fill: "#1268C6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.739 0.4021L25.0942 20.5123H28.5322L21.1771 0.4021H17.739Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2871 0.4021L21.3323 19.5594C21.4292 19.8392 21.6103 20.0815 21.8503 20.2523C22.0903 20.4232 22.3772 20.514 22.6709 20.5123H25.1226L17.7674 0.4021H14.2871Z",
    fill: "#EB3723"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8022 26.3601V22.449C19.8059 21.5047 20.1802 20.6004 20.843 19.934C21.5059 19.2676 22.4033 18.8934 23.3389 18.8934H30.9758C31.9114 18.8934 32.8088 19.2676 33.4717 19.934C34.1345 20.6004 34.5088 21.5047 34.5125 22.449V26.3885H38.0069V22.449C38.0069 20.563 37.2647 18.7543 35.9434 17.4207C34.6222 16.0871 32.8303 15.3379 30.9618 15.3379H23.3389C21.4704 15.3379 19.6784 16.0871 18.3572 17.4207C17.036 18.7543 16.2937 20.563 16.2937 22.449V26.3885L19.8022 26.3601Z",
    fill: "#A74317"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5888 54.0646C47.0795 47.1316 47.5836 35.3821 40.7149 27.8214C33.8462 20.2606 22.2056 19.7517 14.7149 26.6847C7.22423 33.6177 6.72008 45.3672 13.5888 52.928C20.4576 60.4887 32.0981 60.9976 39.5888 54.0646Z",
    fill: "#E1803D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.961 53.4015C46.0732 46.8189 46.5519 35.6632 40.0302 28.4845C33.5086 21.3059 22.4563 20.8227 15.3442 27.4053C8.23205 33.9879 7.75338 45.1437 14.275 52.3223C20.7966 59.501 31.8489 59.9841 38.961 53.4015Z",
    fill: "#A74317"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2202 51.4392C43.2807 45.8259 43.6855 36.3164 38.1242 30.1992C32.563 24.0819 23.1416 23.6734 17.081 29.2867C11.0205 34.9 10.6157 44.4095 16.177 50.5267C21.7383 56.644 31.1596 57.0525 37.2202 51.4392Z",
    fill: "#E1803D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1113 47.1809V44.8769H22.6473V42.7889L27.4173 33.6809H29.5413V42.4469H30.5673V44.8769H29.5413V47.1809H27.1113ZM24.6993 43.4369L24.0873 42.4469H27.1113V38.5229L24.6993 43.4369Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.45
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2493 41.3647C13.2462 38.451 14.0828 35.5993 15.6572 33.1572C17.2317 30.7151 19.4759 28.7879 22.1164 27.6106C24.7568 26.4333 27.6796 26.0566 30.5285 26.5265C33.3773 26.9964 36.0293 28.2926 38.1611 30.2571C36.8039 28.7628 35.1611 27.5612 33.3316 26.7248C31.5021 25.8884 29.5238 25.4345 27.5159 25.3905C25.508 25.3465 23.512 25.7132 21.6482 26.4686C19.7844 27.224 18.0915 28.3524 16.6713 29.7858C15.2511 31.2192 14.1332 32.9281 13.3848 34.8093C12.6364 36.6905 12.2731 38.7051 12.3167 40.7318C12.3604 42.7586 12.81 44.7554 13.6387 46.602C14.4673 48.4486 15.6577 50.1068 17.1382 51.4766C14.6309 48.7179 13.2427 45.1084 13.2493 41.3647V41.3647Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.67
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.598 28.7356C38.9979 31.6261 40.4241 35.2125 40.6702 38.9756C40.6702 42.9625 39.101 46.7862 36.3079 49.6054C33.5149 52.4246 29.7266 54.0084 25.7766 54.0084C22.0458 53.7719 18.4891 52.3309 15.6316 49.8982C16.9526 51.5143 18.5936 52.8339 20.4495 53.7722C22.3054 54.7106 24.3351 55.247 26.4084 55.3471C28.4817 55.4472 30.5529 55.1087 32.489 54.3534C34.4252 53.5981 36.1835 52.4427 37.6512 50.9612C39.119 49.4798 40.2637 47.705 41.012 45.7507C41.7603 43.7965 42.0956 41.706 41.9964 39.6132C41.8973 37.5205 41.3658 35.4718 40.4362 33.5986C39.5065 31.7253 38.1992 30.0689 36.598 28.7356V28.7356Z",
    fill: "#A63A1B"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1294 0.646729L22.4928 18.8085C22.4038 19.0323 22.3726 19.2754 22.4022 19.5148C22.4319 19.7542 22.5214 19.982 22.6623 20.1769C22.8032 20.3717 22.9909 20.5272 23.2078 20.6287C23.4246 20.7301 23.6635 20.7743 23.9019 20.7569H25.3109L32.6661 0.646729H29.1294Z",
    fill: "#1268C6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5817 0.646729L25.2266 20.7569H28.6646L36.0339 0.646729H32.5817Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0192 0.646614L30.3831 16.0066L28.6641 20.7283H31.1158C31.4468 20.725 31.766 20.6042 32.0176 20.387C32.2207 20.232 32.3729 20.0189 32.4544 19.7754L39.4995 0.618164L36.0192 0.646614Z",
    fill: "#EB3723"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.69,
    d: "M34.2864 14.8404L32.4547 19.8039C32.3765 20.0491 32.2236 20.2631 32.0179 20.4155C31.7704 20.6395 31.4485 20.7613 31.1161 20.7568H23.8314C23.5912 20.7753 23.3504 20.7314 23.1318 20.6293C22.9133 20.5271 22.7243 20.3701 22.583 20.1733C22.4417 19.9764 22.3527 19.7463 22.3246 19.5048C22.2965 19.2634 22.3301 19.0187 22.4223 18.7941L29.0307 0.717773L34.2864 14.8404Z",
    fill: "url(#paint5_linear_95_1737)"
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7767 0.646729H21.3386L28.6797 20.7284H31.1032C31.4342 20.7251 31.7535 20.6043 32.005 20.3871L30.3846 15.9782L24.7767 0.646729Z",
    fill: "#1268C6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8994 0.646729L25.2546 20.7569H28.6926L21.3375 0.646729H17.8994Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4478 0.646729L21.4929 19.804C21.5898 20.0838 21.7709 20.3261 22.0109 20.4969C22.2509 20.6678 22.5378 20.7587 22.8315 20.7569H25.2832L17.9281 0.646729H14.4478Z",
    fill: "#EB3723"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_95_1737",
    x1: 16.1474,
    y1: 20.5972,
    x2: 37.8465,
    y2: 20.5972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_95_1737",
    x1: 35.7126,
    y1: 48.9495,
    x2: 16.2433,
    y2: 29.6606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_95_1737",
    x1: 16.9517,
    y1: 29.9864,
    x2: 40.5168,
    y2: 53.3331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_95_1737",
    x1: 45.0857,
    y1: 58.401,
    x2: 8.73539,
    y2: 22.3876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_95_1737",
    x1: 31.167,
    y1: 9.97355,
    x2: 27.7027,
    y2: 11.6406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121E3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_95_1737",
    x1: 31.3274,
    y1: 10.2182,
    x2: 27.8631,
    y2: 11.8853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121E3D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.f5541e5285812470b370ffeeac7a8570.svg";
export { ForwardRef as ReactComponent };